import { createContext } from "react";

import { TUseStarredButtonContextProvider } from "./use-starred-button-context-provider";

const StarredButtonContext = createContext<TUseStarredButtonContextProvider>(
  {} as TUseStarredButtonContextProvider,
);

StarredButtonContext.displayName = "Header starred button";

export { StarredButtonContext };
